// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:is(.dark .json-view, .dark.json-view) {
	color: #d1d1d1;
	--json-property: #009033;
	--json-index: #5d75f2;
	--json-number: #5d75f2;
	--json-string: #c57e29;
	--json-boolean: #e4407b;
	--json-null: #e4407b;
}
:is(.dark .json-view_a11y, .dark.json-view_a11y) {
	color: #d1d1d1;
	--json-property: #ffd700;
	--json-index: #00e0e0;
	--json-number: #00e0e0;
	--json-string: #abe338;
	--json-boolean: #ffa07a;
	--json-null: #ffa07a;
}
:is(.dark .json-view_github, .dark.json-view_github) {
	color: #79b8ff;
	--json-property: #79b8ff;
	--json-index: #79b8ff;
	--json-number: #79b8ff;
	--json-string: #9ecbff;
	--json-boolean: #79b8ff;
	--json-null: #79b8ff;
}
:is(.dark .json-view_vscode, .dark.json-view_vscode) {
	color: #da70d6;
	--json-property: #9cdcfe;
	--json-index: #b5cea8;
	--json-number: #b5cea8;
	--json-string: #ce9178;
	--json-boolean: #569cd6;
	--json-null: #569cd6;
}
:is(.dark .json-view_atom, .dark.json-view_atom) {
	color: #abb2bf;
	--json-property: #e06c75;
	--json-index: #d19a66;
	--json-number: #d19a66;
	--json-string: #98c379;
	--json-boolean: #56b6c2;
	--json-null: #56b6c2;
}
:is(.dark .json-view_winter-is-coming, .dark.json-view_winter-is-coming) {
	color: #a7dbf7;
	--json-property: #91dacd;
	--json-index: #8dec95;
	--json-number: #8dec95;
	--json-string: #e0aff5;
	--json-boolean: #f29fd8;
	--json-null: #f29fd8;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react18-json-view/src/dark.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,wBAAwB;CACxB,qBAAqB;CACrB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,oBAAoB;AACrB;AACA;CACC,cAAc;CACd,wBAAwB;CACxB,qBAAqB;CACrB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,oBAAoB;AACrB;AACA;CACC,cAAc;CACd,wBAAwB;CACxB,qBAAqB;CACrB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,oBAAoB;AACrB;AACA;CACC,cAAc;CACd,wBAAwB;CACxB,qBAAqB;CACrB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,oBAAoB;AACrB;AACA;CACC,cAAc;CACd,wBAAwB;CACxB,qBAAqB;CACrB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,oBAAoB;AACrB;AACA;CACC,cAAc;CACd,wBAAwB;CACxB,qBAAqB;CACrB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,oBAAoB;AACrB","sourcesContent":[":is(.dark .json-view, .dark.json-view) {\r\n\tcolor: #d1d1d1;\r\n\t--json-property: #009033;\r\n\t--json-index: #5d75f2;\r\n\t--json-number: #5d75f2;\r\n\t--json-string: #c57e29;\r\n\t--json-boolean: #e4407b;\r\n\t--json-null: #e4407b;\r\n}\r\n:is(.dark .json-view_a11y, .dark.json-view_a11y) {\r\n\tcolor: #d1d1d1;\r\n\t--json-property: #ffd700;\r\n\t--json-index: #00e0e0;\r\n\t--json-number: #00e0e0;\r\n\t--json-string: #abe338;\r\n\t--json-boolean: #ffa07a;\r\n\t--json-null: #ffa07a;\r\n}\r\n:is(.dark .json-view_github, .dark.json-view_github) {\r\n\tcolor: #79b8ff;\r\n\t--json-property: #79b8ff;\r\n\t--json-index: #79b8ff;\r\n\t--json-number: #79b8ff;\r\n\t--json-string: #9ecbff;\r\n\t--json-boolean: #79b8ff;\r\n\t--json-null: #79b8ff;\r\n}\r\n:is(.dark .json-view_vscode, .dark.json-view_vscode) {\r\n\tcolor: #da70d6;\r\n\t--json-property: #9cdcfe;\r\n\t--json-index: #b5cea8;\r\n\t--json-number: #b5cea8;\r\n\t--json-string: #ce9178;\r\n\t--json-boolean: #569cd6;\r\n\t--json-null: #569cd6;\r\n}\r\n:is(.dark .json-view_atom, .dark.json-view_atom) {\r\n\tcolor: #abb2bf;\r\n\t--json-property: #e06c75;\r\n\t--json-index: #d19a66;\r\n\t--json-number: #d19a66;\r\n\t--json-string: #98c379;\r\n\t--json-boolean: #56b6c2;\r\n\t--json-null: #56b6c2;\r\n}\r\n:is(.dark .json-view_winter-is-coming, .dark.json-view_winter-is-coming) {\r\n\tcolor: #a7dbf7;\r\n\t--json-property: #91dacd;\r\n\t--json-index: #8dec95;\r\n\t--json-number: #8dec95;\r\n\t--json-string: #e0aff5;\r\n\t--json-boolean: #f29fd8;\r\n\t--json-null: #f29fd8;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
